<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.requiresSignature.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.requiresSignature.description') }}
    </p>
    <div class="w-full">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="signature-required"
        @change="update"
        data-vs-radio-button="signatureRequired"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.requiresSignature.option.label') }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="signature-required"
        @change="update"
        data-vs-radio-button="signatureRequired"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.requiresSignature.option1.label') }}</span>
      </zt-radio-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignatureRequires',
  inject: ['stateFolder', 'setParams'],
  data() {
    return {
      selected: 'false'
    }
  },
  created() {
    this.selected = this.stateFolder.params.signature.toString()
  },
  methods: {
    update() {
      const signature = (/^(true|1)$/i).test(this.selected) && !!this.selected
      this.setParams({
        ephemeral: false,
        signature,
        visible: true,
      })
      this.$emit('signature-change', signature)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>